import React from "react";
import { Divider as BaseDivider, DividerProps, TextProps } from "@chakra-ui/react";
import { Row } from "~/components/elements/grid/Row";
import { UiText } from "~/components/elements/UiText";

interface Props extends DividerProps {
  text?: string;
  textProps?: TextProps;
  containerProps?: any;
}

export const UiDivider = React.forwardRef(
  ({ text, textProps, style, containerProps, ...rest }: Props, ref: React.ForwardedRef<any>) => {
    if (!text) {
      return <BaseDivider borderColor="neutral.gray200" style={style} {...rest} />;
    }

    const dividerStyle: DividerProps["style"] = {
      flex: 1,
      alignSelf: "center",
      ...style,
    };

    return (
      <Row ref={ref} {...containerProps}>
        <BaseDivider style={dividerStyle} borderColor="neutral.gray200" {...rest} />
        <UiText color="neutral.gray600" vr="body2" alignSelf="center" mx={2} {...textProps}>
          {text}
        </UiText>
        <BaseDivider style={dividerStyle} borderColor="neutral.gray200" {...rest} />
      </Row>
    );
  }
);
